/* eslint-disable */
// Note: This is a build artifact. Do not modify directly.
// This file is generated by the make-client-config-file script.
// Secure values should NEVER appear in this file.
export default {
  ENVIRONMENT: 'production',
  IS_ENABLED: true,
  SIGN_OUT_URL: 'https://phet-direct.colorado.edu/logout',
  VALID_METADATA_DURATION: 1800000,
  WEBSITE_USER_DATA_URL: 'https://phet-direct.colorado.edu/user/check-login',
};